export default __webpack_public_path__ + "static/default-social-377808ff4c0e3336b608786bb05631fe.png";